import React from 'react';
import BasicInformation from './ProductDetails/BasicInformation';
import MarketInformation from './ProductDetails/MarketInformation';
import Costs from './ProductDetails/Costs';
import AdditionalInformation from './ProductDetails/AdditionalInformation';

const ProductDetails = ({ publishData }) => {
  console.log('ProductDetails - publishData:', publishData);
  console.log('ProductDetails - ProductInfo:', publishData?.ProductInfo);
  
  if (!publishData?.ProductInfo) {
    console.log('ProductDetails - No ProductInfo found');
    return <div>No product information available.</div>;
  }
  
  const productInfo = publishData.ProductInfo;
  console.log('ProductDetails - productInfo:', productInfo);
  
  return (
    <div className="space-y-6">
      <BasicInformation productInfo={productInfo} />
      <MarketInformation productInfo={productInfo} />
      <Costs productInfo={productInfo} />
      <AdditionalInformation productInfo={productInfo} />
    </div>
  );
};

export default ProductDetails; 